import { PageSection } from "@/types/pageBuilder";

import Hero from "@/components/hero/Hero";
import HeroSimple from "@/components/hero/heroSimple/HeroSimple";
import Faq from "@/components/faqs/Faqs";
import CTA from "@/components/cta/Cta";
import DoulaTypes from "@/components/doulaTypes/DoulaTypes";
import HowItWorks from "@/components/howItWorks/HowItWorks";
import Benefits from "@/components/benefits/Benefits";
import CardInfo from "@/components/card/CardInfo";
import { Alert, AlertTitle } from "@/components/ui/alert";

import "./LandingPage.css";

type LandingPageProps = {
	pageTitle?: string;
	pageBuilder?: PageSection[] | null;
};

export default function LandingPage({ pageBuilder }: LandingPageProps) {
	return (
		<main className="min-h-screen bg-white">
			{pageBuilder?.map((section, index) => {
				switch (section.__component) {
					case "hero.hero":
						return (
							<Hero
								key={section.__component}
								{...section}
							/>
						);
					case "hero.hero-simple":
						return (
							<HeroSimple
								key={section.__component}
								title={section.title}
								subTitle={section.subTitle}
								updatedDate={section.updatedDate}
							/>
						);
					case "features-section.features-section":
						return (
							<Benefits
								key={section.__component}
								title={section.title}
								subTitle={section.subTitle}
								benefits={section.listItems}
								image={section.image}
							/>
						);
					case "doula-type.doula-type":
						return (
							<DoulaTypes
								key={section.id}
								doulaTypes={section.doulaTypes}
								sectionBgColor={section.sectionBgColor}
								title={section.title}
								subTitle={section.subTitle}
							/>
						);
					case "card.card-info":
						return (
							<CardInfo
								key={section.id}
								cardIcon={section.cardIcon}
								cardTitle={section.cardTitle}
								cardContent={section.cardContent}
								index={index}
								shouldStandOut={section.shouldStandOut}
								textAlignment={section.textAlignment}
							/>
						);
					case "steps-section.steps-section":
						return (
							<HowItWorks
								key={section.__component}
								label={section.label}
								title={section.title}
								image={section.image}
								listItems={section.listItems}
							/>
						);
					case "cta.call-to-action":
						return (
							<CTA
								key={section.__component}
								sectionBgColor={section.sectionBgColor}
								title={section.title}
								content={section.content}
								button={section.button}
							/>
						);
					case "faq-section.faq-section":
						return (
							<Faq
								key={section.__component}
								title={section.title}
								description={section.description}
								faqs={section.faqs}
							/>
						);
					default:
						return (
							<Alert variant="warning" className="max-w-xl mx-auto mt-10" key={index}>
								<AlertTitle className="text-lg font-semibold">No Components Found.</AlertTitle>
							</Alert>
						);
				}
			})}
		</main>
	);
}
